import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { Form, InputNumber, Button, message } from 'antd';
// import validationRegex from '../utils/validationRegex';

import MUTATION from '../graphql/mutations/storeCustomerCmaMutation.graphql';
import QUERY from '../graphql/queries/getCustomerCmaQuery.graphql';

const FormItem = Form.Item;

const labelColXsSpan = 4;
const formItemLayout = {
  labelCol: {
    xs: { span: labelColXsSpan },
  },
  wrapperCol: {
    xs: { span: 6 },
  },
};

const submitBtnLayout = {
  wrapperCol: {
    xs: {
      offset: labelColXsSpan,
    },
  },
};

class NewCmaForm extends Component {
  state = {
    showMonthsForm: false,
    submittingForm: false,
    fys: [],
  };

  getMonthsFormItems = () => {
    const { fys } = this.state;
    const { getFieldDecorator } = this.props.form;
    return fys.map((fy) => (
      <FormItem
        key={fy.year}
        hasFeedback
        label={fy.year}
        {...formItemLayout}
      >
        {
          getFieldDecorator(
            `${fy.year}`,
            {
              initialValue: 12,
              rules: [
                {
                  required: true,
                  message: 'Field is required!',
                },
              ],
            },
          )(<InputNumber min={1} step={1} max={12} />)
        }
      </FormItem>
    ));
  };

  handleShowMonthsForm = () => {
    this.props.form.validateFieldsAndScroll((err, values) => {
      const { estimated_year, audited_years_count, projected_years_count } = values;
      if (!err) {
        const newFys = [];
        // Audited years
        for (let i = (audited_years_count + 1); i > 0; i--) {
          newFys.push({
            year: estimated_year - i,
            months: null,
            type: 'audited',
          });
        }
        // Estimated year
        newFys.push({
          year: estimated_year,
          months: null,
          type: 'estimated',
        });
        // Projection years
        for (let i = 1; i <= projected_years_count; i++) {
          newFys.push({
            year: estimated_year + i,
            months: null,
            type: 'projection',
          });
        }

        this.setState({
          showMonthsForm: true,
          fys: newFys,
        });
      }
    });
  };

  handleSubmit = (event) => {
    this.setState({
      submittingForm: true,
    });
    event.preventDefault();

    const { customer_id } = this.props;

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const {
          estimated_year,
          audited_years_count,
          projected_years_count,
          ...months
        } = values;

        const { fys } = this.state;
        fys.forEach((fy) => {
          fy.months = months[fy.year];
        });

        this.props.mutate({
          variables: { customer_id, estimated_year, audited_years_count, projected_years_count, months_each_year: JSON.stringify(fys) },
          update: (cache, { data: { newCustomerCma } }) => {
            const data = cache.readQuery({
              query: QUERY,
              variables: { customer_id },
            });
            data.customerCma = newCustomerCma;
            cache.writeQuery({ query: QUERY, variables: { customer_id }, data });
          },
        })
          .then(() => {
            this.setState({
              submittingForm: false,
            });
            this.props.form.resetFields();
            message.success('Success!');
          })
          .catch((mutateErr) => {
            console.log(mutateErr);
            this.setState({
              submittingForm: false,
            });
            message.error(mutateErr.message);
          });
      } else {
        console.log(err);
        this.setState({
          submittingForm: false,
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit}>
        <FormItem
          hasFeedback
          label="Estimated year"
          {...formItemLayout}
        >
          {
            getFieldDecorator(
              'estimated_year',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<InputNumber min={1950} step={1} />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="No. of audited years"
          {...formItemLayout}
        >
          {
            getFieldDecorator(
              'audited_years_count',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<InputNumber min={1} step={1} />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="No. of projection years"
          {...formItemLayout}
        >
          {
            getFieldDecorator(
              'projected_years_count',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<InputNumber min={1} step={1} />)
          }
        </FormItem>
        {
          this.state.showMonthsForm ?
            <div>
              <h5>Set no. of months for each year</h5>
              {
                this.getMonthsFormItems()
              }
              <FormItem {...submitBtnLayout}>
                <Button type="primary" htmlType="submit" loading={this.state.submittingForm}>Submit</Button>
              </FormItem>
            </div>
            :
            <FormItem {...submitBtnLayout}>
              <Button type="primary" onClick={this.handleShowMonthsForm}>Set months for each year</Button>
            </FormItem>
        }
      </Form>
    );
  }
}

NewCmaForm.propTypes = {
  mutate: PropTypes.func.isRequired,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func,
    validateFieldsAndScroll: PropTypes.func,
    resetFields: PropTypes.func,
  }).isRequired,
  customer_id: PropTypes.string.isRequired,
};

export default compose(
  graphql(MUTATION),
  Form.create(),
)(NewCmaForm);



// WEBPACK FOOTER //
// ./src/forms/NewCmaForm.jsx